interface BlogContentProps {
  html: string;
}

const BlogContent = ({ html }: BlogContentProps) => {
  return (
    <div
      className="blog-content prose prose-slate max-w-none"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export default BlogContent;
